import type { IconProps } from '../types/IconProps.ts';
export const Divide: IconProps = {
    name: 'Divide',
    children: [
        `<path d="M5 12h14" />`,
        `<circle cx="12" cy="7" r="1" />`,
        `<circle cx="12" cy="17" r="1" />`,
    ]
};